import { useMemo } from 'react';
import { startCase } from 'lodash';
import FilterDropdown from 'components/elements/Dropdown/FilterDropdown';
import { useAvailableCities } from 'hooks/useUserCityAccess';
import { useCompanyCityFilter, useCompanyRegionFilter } from 'state/filterCompanies';

const CityFilter = () => {
  const { cityFilter, setCityFilter } = useCompanyCityFilter();
  const { regionFilter } = useCompanyRegionFilter();
  const { availableRegions } = useAvailableCities();

  const cityOptions = useMemo(() => {
    if (!regionFilter || regionFilter.length === 0) {
      return [];
    }

    return regionFilter
      .flatMap((regionCode) => availableRegions[regionCode]?.cities || [])
      .filter((city, index, self) => index === self.findIndex((c) => c.id === city.id))
      .map(({ code, name }) => ({
        value: code,
        label: startCase(name.toLowerCase()),
      }));
  }, [availableRegions, regionFilter]);

  const handleChange = (values: string[]) => {
    setCityFilter(values);
  };

  return (
    <FilterDropdown
      options={cityOptions}
      checkedValues={cityFilter}
      setCheckedValues={handleChange}
      onClearAll={() => setCityFilter([])}
      maxHeight="280px"
      isFilterEnabled
      sortSelectedFirst
    >
      City/Town
    </FilterDropdown>
  );
};

export default CityFilter;
